import { render, staticRenderFns } from "./reportesTorre.vue?vue&type=template&id=cebf8a1a&scoped=true&"
import script from "./reportesTorre.vue?vue&type=script&lang=ts&"
export * from "./reportesTorre.vue?vue&type=script&lang=ts&"
import style0 from "./reportesTorre.vue?vue&type=style&index=0&id=cebf8a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebf8a1a",
  null
  
)

export default component.exports